import {Component, HostListener, input, InputSignal, output, OutputEmitterRef,} from "@angular/core";
import {PreventMultipleClickDirective} from '../../../directives/prevent-multiple-click.directive';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-secondary-button',
  imports: [
    PreventMultipleClickDirective,
    MatProgressSpinner
  ],
  templateUrl: './secondary-button.component.html',
  styleUrls: ['../styles.css', './secondary-button.component.css']
})
export class SecondaryButtonComponent {
  isDisabled: InputSignal<any> = input(false);
  isLoading: InputSignal<any> = input(false);
  buttonId: InputSignal<any> = input('');
  type: InputSignal<any> = input('');

  handleClick: OutputEmitterRef<any> = output();
  handleKeypressEnter: OutputEmitterRef<void> = output();

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.handleKeypressEnter.emit();
    }
  }
}
